/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type OpenOutOfCreditModalActionActionType =
  (typeof OpenOutOfCreditModalActionActionType)[keyof typeof OpenOutOfCreditModalActionActionType];

export const OpenOutOfCreditModalActionActionType = {
  open_out_of_credits: 'open_out_of_credits',
} as const;
